import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import testimonialsQuoteMark from "@/assets/images/icons/testimonialsQuoteMark.webp";

import testimonialCardShape from "@/assets/images/testimonialCardShape.svg?url";
import type { Testimonial } from "@/data/testimonials";

export default function TestimonialCard({ data }: { data: Testimonial }) {
  return (
    <Box sx={{
            position: "relative",
            width: "100%",
            maxWidth: 720,
            mx: "auto",
            aspectRatio: "493 / 311",
            color: "text.secondary",
        }}>
        <Image src={testimonialCardShape} alt="testimonial card shape" 
            width={100} height={100} style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%", 
            }}/>
        <Stack sx={{
                position: "relative",
                height: "100%",
                justifyContent: "space-between",
                px: { xs: 3, sm: 5, md: 4, lg: 3, xl: 2 },
                py: { xs: 3, sm: 5, md: 4, lg: 3, xl: 2 },
            }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{
                    pl: { xs: 8, sm: 9, md: 8, lg: 6, xl: 10 },
                    pr: { xs: 0, sm: 3, md: 0, lg: 0, xl: 0 },
                    py: { xs: 1, sm: 0, lg: 0, xl: 1.5 },
                    pb: { xs: 0, sm: 0, lg: 2, xl: 0 },
                }}>
                <Stack gap={0.5}>
                    <Typography variant="body2" fontWeight={400}>
                        {data.first_name} {data.last_name}
                    </Typography>
                    <Typography variant="body2" fontWeight={300} fontSize={{ xs: "0.75rem", sm: "0.8rem", md: "0.85rem", lg: "0.7rem", xl: "0.95rem" }}>
                        {data.company} &middot; {data.position}
                    </Typography>
                </Stack>
                <Box sx={{
                        position: "relative",
                        width: { xs: 28, sm: 36, md: 40 },
                        height: { xs: 28, sm: 36, md: 32 },
                        flexShrink: 0,
                    }}>
                    <Image src={testimonialsQuoteMark} alt="quote" fill />
                </Box>
            </Stack>

            <Typography sx={{
                    fontWeight: 300,
                    fontSize: { xs: "0.85rem", sm: "0.85rem", md: "0.9rem", lg: "0.95rem", xl: "1rem" },
                    px: { xs: 1, sm: 2, md: 1, lg: 0.5, xl: 1 },
                    pb: { xs: 3, sm: 4, lg: 6, xl: 7 },
                }}>
                {data.content}
            </Typography>
        </Stack>
    </Box>
  );
}